import { Ely1PerformanceObject } from '../'

export const getPerformanceObject = (rumObject): Ely1PerformanceObject => {
  const stats: Ely1PerformanceObject = {
    navigationTime: rumObject.loadEventStart - rumObject.navigationStart,
    redirectTime: 0,
    cacheTime: rumObject.domainLookupStart - rumObject.fetchStart,
    dnsTime: rumObject.domainLookupEnd - rumObject.domainLookupStart,
    connectionTime: rumObject.connectEnd - rumObject.connectStart,
    backendLoadTime: rumObject.responseEnd - rumObject.requestStart,
    domInteractiveTime: rumObject.domInteractive - rumObject.navigationStart,
    domParsingTime: rumObject.domInteractive - rumObject.domLoading,
    domReadyTime: rumObject.domComplete - rumObject.domInteractive,
    frontendLoadTime: rumObject.loadEventStart - rumObject.domInteractive,
  }
  return stats
}
